export default {
  ConvertHostnameToLowercase(url: string) {
    let urlParts = url.split("/");

    if (url.indexOf("//") > -1) {
      urlParts[2] = urlParts[2].toLowerCase();
    } else {
      urlParts[0] = urlParts[0].toLowerCase();
    }

    return urlParts.join("/");
  },
  GenerateUniqueId() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  },
  IsHttps(source: string) {
    const pattern = new RegExp("^(https://)");
    return pattern.test(source);
  },
  TryAddScheme(url: string, schemeToAdd: string) {
    const regex = /^(http|https|ftp|sftp)/;
    if (
      !url.match(regex) &&
      schemeToAdd !== "none" &&
      schemeToAdd !== undefined &&
      !this.ValidateUrl(url)
    ) {
      return `${schemeToAdd}${url}`;
    }

    return url;
  },
  ValidateUrl(source: string) {
    const pattern = /^(?:(?:https?):\/\/)(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

    // Flag the request as invalid
    // This disables the request to be send to the API
    return pattern.test(source);
  },
};
